
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.11 40.58a1 1 0 000-2 4.87 4.87 0 01-4.87-4.86 4.88 4.88 0 014.87-4.87 1 1 0 100-2 6.88 6.88 0 00-6.87 6.87 6.87 6.87 0 006.87 6.86zM33.613 38.873a1 1 0 01.707-.293 4.87 4.87 0 004.86-4.86 4.87 4.87 0 00-4.86-4.87 1 1 0 110-2 6.87 6.87 0 016.86 6.87 6.87 6.87 0 01-6.86 6.86 1 1 0 01-.707-1.707z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.36 24.3c0-5.3-1.27-6.24-3.51-7.43l-.56-.3a7.003 7.003 0 01-1.9-1.36 2.54 2.54 0 002.42-2.53v-2.14A2.54 2.54 0 0040.27 8H20.18a2.54 2.54 0 00-2.54 2.54v2.14a2.53 2.53 0 002.42 2.53 7.003 7.003 0 01-1.91 1.36l-.55.3c-2.18 1.16-3.44 2.09-3.51 7a.9.9 0 00-.01.77v18.3a8.35 8.35 0 008.56 8.32h15.17a8.359 8.359 0 008.56-8.32V24.27l-.01.03zM19.63 12.67v-2.14a.54.54 0 01.54-.54h20.09a.55.55 0 01.54.54v2.14a.54.54 0 01-.54.54H20.17a.54.54 0 01-.54-.54zm-1.1 6l.59-.32c1.75-1 2.8-1.79 3.14-3.09h15.91c.33 1.3 1.39 2.12 3.14 3.09.16.096.319.179.473.259l.117.061c1.58.85 2.32 1.25 2.44 4.68H16.09c.11-3.48.85-3.88 2.44-4.73v.05zM37.8 49.34H22.63a6.3 6.3 0 01-6.46-5.21h28.08a6.29 6.29 0 01-6.45 5.16v.05zm6.56-7.21H16.07V25.35h28.29v16.78z"}})])
          )
        }
      }
    